import api from '../baseApi';
import type { PodProductImagesMetadata } from '@/typings/customilyElements/podProductImages';
import type {
    MatchVariantAndPlaceholderPayload,
    PodAssignment,
    TemplateProduct,
    TemplateProductCategoryAssignDto,
    TemplateProductsListResult,
    TemplateProductVariant,
    Variant
} from '../typings/templateProducts';
import { PodProviderConfiguration } from '@/components/TemplateProductPodAssigner/typings';

const controllerPath = '/Admin/TemplateProducts';

export const listTemplateProducts = async (
    from: number,
    count: number,
    search?: string,
    sortBy?: string,
    sortMode?: string,
    filterByGuideLines = false
): Promise<TemplateProductsListResult> => {
    return api
        .get<TemplateProductsListResult>(controllerPath, {
            params: {
                from,
                count,
                sortBy,
                sortMode,
                search: search?.toLocaleLowerCase(),
                filterByGuideLines
            }
        })
        .then(({ data }) => data);
};

export const getTemplateProduct = async (
    id: string,
    pod = '',
    isChildTemplateProduct = false,
    useListEPS = true
): Promise<TemplateProduct> => {
    const includeVariants = !['Printful', 'Printify'].includes(pod) && !isChildTemplateProduct;
    const response = await api.get(`${controllerPath}/${id}/${includeVariants}`, { params: { useListEPS } });
    return response.data;
};

export const cloneTemplateProduct = async (id: string): Promise<TemplateProduct> => {
    const response = await api.post(`${controllerPath}/${id}/Clone`);
    return response.data;
};

export const deleteTemplateProduct = async (id: string): Promise<TemplateProduct> => {
    const response = await api.delete(`${controllerPath}/${id}`);
    return response.data;
};

export const getTemplateProductColorImages = async (
    podAssignment: PodAssignment
): Promise<PodProductImagesMetadata> => {
    const response = await api.post(`${controllerPath}/ColorImages`, podAssignment);
    return response.data;
};

export const getProductManualVariants = (id: string): Promise<TemplateProductVariant> =>
    api.get(`/Admin/TemplateProductVariants/ManualVariantsForMatching/${id}`).then(({ data }) => data);

export const linkManualVariants = (params: MatchVariantAndPlaceholderPayload): Promise<void> =>
    api.post(`/Admin/TemplateProductVariants/ManualVariantsMatched`, params);

export const assignDesignCategories = (payload: TemplateProductCategoryAssignDto): Promise<void> =>
    api.post(`/Admin/TemplateProducts/Categories`, payload);

export const getPodAssignments = (id: string): Promise<PodAssignment[]> =>
    api.get(`/Admin/TemplateProducts/${id}/PodAssignments`).then(({ data }) => data);
